import(/* webpackMode: "eager" */ "/app/fo/src/app/publier/page.tsx");
